import React from "react";
import { motion } from "framer-motion";

/**
 * PageTransition - компонент для плавных переходов между страницами
 * Использует эффект scale для приятной анимации, как в TwinBuy
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Контент страницы
 * @param {string} props.className - Дополнительные CSS классы
 */
const PageTransition = ({ children, className = "" }) => {
  // Варианты анимации для входа/выхода страницы
  const pageVariants = {
    initial: {
      opacity: 1,
      scale: 1,
    },
    in: {
      opacity: 1,
      scale: 1,
    },
    out: {
      opacity: 0,
      scale: 1.03, // Легкое увеличение при выходе
      filter: "brightness(0.85)", // Мягкое затемнение при выходе
    },
  };

  // Настройки плавности анимации
  const pageTransition = {
    type: "tween",
    ease: [0.25, 0.1, 0.25, 1], // Более плавный cubic bezier
    duration: 0.4, // Увеличенная длительность для плавности
  };

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      className={`absolute inset-0 w-full h-full overflow-auto ${className}`}
      style={{ transformOrigin: "center center" }} // Масштабирование из центра
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
